// Utility functions for Neuroa components
export function stripTrailingSlash(s) {
  return (s || "").replace(/\/+$/, "");
}

 // ensures the chatkit web component is defined, waiting up to timeoutMs milliseconds
export async function ensureChatKitElementDefined(timeoutMs = 8000) {
  const tag = "openai-chatkit";
  if (window.customElements && window.customElements.get(tag)) return;

  if (!window.customElements || !window.customElements.whenDefined) {
    throw new Error("customElements.whenDefined not available.");
  }

  await Promise.race([
    window.customElements.whenDefined(tag),
    new Promise((_, reject) =>
      setTimeout(() => reject(new Error("ChatKit script timeout.")), timeoutMs),
    ),
  ]);

  if (!window.customElements.get(tag)) {
    throw new Error("ChatKit custom element was not registered.");
  }
}
